import { render, staticRenderFns } from "./dashboardLegal.vue?vue&type=template&id=c18798ac&"
import script from "./dashboardLegal.vue?vue&type=script&lang=js&"
export * from "./dashboardLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports